import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconDomain = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M13.1061 5.62259C13.5142 5.45932 13.9193 5.86436 13.756 6.27252L11.7074 11.394C11.6808 11.4607 11.5946 11.4783 11.5439 11.4276L7.95103 7.83473C7.90026 7.78397 7.91794 7.69784 7.9846 7.67118L13.1061 5.62259Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6.38892 13.6397C5.98077 13.803 5.57573 13.398 5.73899 12.9898L7.78758 7.86834C7.81424 7.80168 7.90037 7.784 7.95114 7.83476L11.544 11.4276C11.5947 11.4784 11.5771 11.5645 11.5104 11.5912L6.38892 13.6397Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="9.5" cy="9.5" r="8.75" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconDomain
